import React from "react"
import styled, { useTheme } from '~/ui/styled'
import { Text as TextCore } from "~widgets/text"

const TagText = styled(TextCore)<{ color?: string }>`
  font-size: 12px;
  padding: 2px 4px;
  color: ${({ theme, color }) => color || theme.colors.primary};
`

const TagWrap = styled.View<{ bColor?: string; bgColor?: string }>`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background-color: transparent;
  border: 1px solid;
  margin-left: 4px;
  border-color: ${({ bColor }) => bColor || "transparent"};
  background-color: ${({ bgColor }) => bgColor || "transparent"};
`

export const Tag = ({ role }) => {
const theme = useTheme()
  switch (role) {
    case 1:
      return (
        <TagWrap bgColor={"#f8b762"}>
          <TagText color={"#563100"}>红包APP客服号</TagText>
        </TagWrap>
      )
    case 2:
      return (
        <TagWrap bColor={theme.colors.primary}>
          <TagText>商户客服号</TagText>
        </TagWrap>
      )
    default:
      return null
  }
}
